import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useHotjar } from '@savgroup-front-common/core/components/HotjarProvider';
import { selectLocale } from '@savgroup-front-common/core/domains/i18n/selectors';
import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';
import { sellerSelectors } from '@savgroup-front-common/core/domains/sellers';
import { useIsAdmin } from '@savgroup-front-common/core/hooks';

const useUserTracking = () => {
  const { firstname: firstName, lastname: lastName, mail: email, id: userId } =
    useCurrentUser();
  const locale = useSelector(selectLocale);

  const tenants = useSelector(sellerSelectors.selectTenants);

  const { isHotjarEnabled, hotjar } = useHotjar();
  const isAdmin = useIsAdmin();

  useEffect(() => {
    if (isHotjarEnabled && !isAdmin) {
      hotjar.identify(userId, {
        email,
        locale,
        firstName,
        lastName,
        tenants: tenants.reduce((acc, { name }) => `${acc}, ${name}`, ''),
      });
    }
  }, [
    email,
    firstName,
    hotjar,
    isAdmin,
    isHotjarEnabled,
    lastName,
    locale,
    tenants,
    userId,
  ]);
};

export default useUserTracking;
